import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { AlyceTheme, Icon, Tooltip } from '@alycecom/ui';

const useStyles = makeStyles<AlyceTheme>(({ spacing, breakpoints }) => ({
  hintTooltip: {
    position: 'absolute',
    top: 'calc(50% - 9px)',
    right: spacing(-3),
    [breakpoints.down('sm')]: {
      display: 'none',
    },
  },
}));

export interface IInfoTooltipProps {
  title: string;
  dataTestId: string;
}

const InfoTooltip = ({ title, dataTestId }: IInfoTooltipProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Tooltip title={title} placement="top-start" className={classes.hintTooltip}>
      <span>
        <Icon data-testid={dataTestId} color="grey.main" icon="info-circle" fontSize={1} />
      </span>
    </Tooltip>
  );
};

export default memo<IInfoTooltipProps>(InfoTooltip);
